import React from 'react';
import Slider from './Slider.jsx';

const AboutSection = (props) =>
	<div>
		<div className={`h anime ${props.showAnime?'show':''}`}>{props.data.title}</div>
		<Slider img={props.data.img} arrow={true} showAnime={props.showAnime}/>
		<div className={`des anime ${props.showAnime?'show':''}`}>
			{props.data.text}
		</div>
	</div>

export default AboutSection;